ApiInterceptor.$inject = ["$q", "gplansConf"];configureApiInterceptors.$inject = ["$httpProvider"];function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}export var ApiHttpService = /*#__PURE__*/function () {ApiHttpService.$inject = ["$http", "gplansConf"];

  function ApiHttpService($http, gplansConf) {
    "ngInject";_classCallCheck(this, ApiHttpService);
    this.$http = $http;
    this.gplansConf = gplansConf;

  }_createClass(ApiHttpService, [{ key: "apiUrl", value: function apiUrl(



    str) {return "".concat(this.apiBase).concat(str);} }, { key: "apiBase", get: function get() {return this.gplansConf.API_URL;} }, { key: "survey", get: function get()

    {return this.apiUrl("/api/v1/surveys/");} }, { key: "userSurvey", get: function get()
    {return this.apiUrl("/api/v1/usersurveys/");} //   query,get,post
  }, { key: "userSurveyAnswer", get: function get()
    {return this.apiUrl("/api/v1/usersurveys/{surveyId}/surveyanswers/");} //query, get, delete
  }, { key: "metabolicType", get: function get()
    {return this.apiUrl("/api/v1/metabolictypes/");} // query, get
  }, { key: "authCheck", get: function get()
    {return this.apiUrl("/api/v1/auth/check/");} // post
  }, { key: "authRegister", get: function get() {return this.apiUrl("/api/v1/auth/register/");} // post
  }, { key: "authCreateAccount", get: function get() {return this.apiUrl("/api/v1/auth/create_account/");} // post
  }, { key: "authQuizComplete", get: function get() {return this.apiUrl("/api/v1/auth/quiz-complete-link/");} // post
  }, { key: "authFacebookLogin", get: function get()
    {return this.apiUrl("/api/v1/auth/facebook/login/");} //post
  }, { key: "authFacebookRegister", get: function get() {return this.apiUrl("/api/v1/auth/facebook/register/");} //post
  }, { key: "authFacebookDisconnect", get: function get() {return this.apiUrl("/api/v1/auth/facebook/disconnect/");} //post
  }, { key: "authFacebookConnect", get: function get() {return this.apiUrl("/api/v1/auth/facebook/connect/");} //post
  }, { key: "accountUid", get: function get()
    {return this.apiUrl("/api/v1/accounts/uid/");} // get
  }, { key: "account", get: function get() {return this.apiUrl("/api/v1/accounts/");} // delete, get, put. 'profileId' for delete, 'username' for get,put
  }, { key: "accountGroceriesListEmail", get: function get() {return this.apiUrl("/api/v1/accounts/send-groceries-list-email/");} // get
  }, { key: "userName", get: function get()
    {return this.apiUrl("/api/v1/usernames/");} // get
  }, { key: "paypalExecute", get: function get() {return this.apiUrl("/api/v1/paypal/payment/execute/");} // post
  }, { key: "upsell", get: function get() {return this.apiUrl("/api/v1/upsell/");} // post
  }, { key: "customers", get: function get()
    {return this.apiUrl("/api/v1/customers/");} // post
  }, { key: "customerOrder", get: function get() {return this.apiUrl("/api/v1/customers/{customerId}/orders/");} // post
  }, { key: "checkin", get: function get()
    {return this.apiUrl("/api/v1/checkins/");} // query, get, post, put
  }, { key: "newMymealplan", get: function get()
    {return this.apiUrl("/api/v2/new-mymealplan/");} // get
  }, { key: "foods", get: function get() {return this.apiUrl("/api/v1/foods/");} // get
  }, { key: "swaps", get: function get() {return this.apiUrl("/api/v1/swaps/");} // post
  }, { key: "searchFood", get: function get() {
      return this.apiUrl("/api/v1/search-nutrients/");
    } // get
  }, { key: "freeFoods", get: function get() {return this.apiUrl("/api/v1/freefoods/");} // get
  }, { key: "userMeals", get: function get()
    {return this.apiUrl("/api/v2/usermeals/");} // post, put, delete
  }, { key: "userMealItems", get: function get() {return this.apiUrl("/api/v2/usermealitems/");} // post, put, delete
  }, { key: "userExtraMealItems", get: function get() {return this.apiUrl("/api/v2/userextramealitems/");} // post
  }, { key: "waterTrackers", get: function get()
    {return this.apiUrl("/api/v1/watertrackers/");} // get, put, post
  }, { key: "exerciseTrackers", get: function get() {return this.apiUrl("/api/v1/exercisetrackers/");} // get, put, post
  }, { key: "exercise", get: function get() {return this.apiUrl("/api/v1/exercise/");} // get
  }, { key: "loggedExercise", get: function get()
    {return this.apiUrl("/api/v1/loggedexercise/");} // post, delete
  }, { key: "loggedMeals", get: function get() {return this.apiUrl("/api/v2/loggedmeals/");} // post, delete
  }, { key: "loggedMealitems", get: function get() {return this.apiUrl("/api/v2/loggedmealitems/");} // post, delete
  }, { key: "misc", get: function get()
    {return this.apiUrl("/api/v1/misc/");} // post, put, get
  }, { key: "miscCustomMeal", get: function get() {return this.apiUrl("/api/v1/misc/customMeal/");} // post, put, get
  }, { key: "coaching", get: function get()
    {return this.apiUrl("/api/v1/coaching/");} // query, get
  }, { key: "nutritionistsTimeslots", get: function get()
    {return this.apiUrl("/api/v1/nutritionists/timeslots/");} // get
  }, { key: "nutritionistsCreateSetmoreCustomer", get: function get() {return this.apiUrl("/api/v1/nutritionists/create-setmore-customer/");} // get
  }, { key: "nutritionistsCreateSetmoreAppointment", get: function get() {return this.apiUrl("/api/v1/nutritionists/create-setmore-appointment/");} // get
  }, { key: "achievements", get: function get()
    {return this.apiUrl("/api/v1/achievements/");} // get
  }, { key: "recipes", get: function get()
    {return this.apiUrl("/api/v2/recipes/");} // get
  }, { key: "mealRecipes", get: function get() {return this.apiUrl("/api/v2/meal-recipes/");} // get
  }, { key: "swapableRecipes", get: function get() {return this.apiUrl("/api/v1/swappable-recipes-for-meals/?restrictions=1");} // get
  }, { key: "tags", get: function get()
    {return this.apiUrl("/api/v2/tags/");} // get
  }, { key: "tips", get: function get() {return this.apiUrl("/api/v2/tips/");} // get
  }, { key: "recommendedRecipes", get: function get()
    {return this.apiUrl("/api/v2/recipes-recommended/");} }, { key: "content", get: function get()

    {return this.apiUrl("/api/v1/content/");} // query, get, post, put
  }, { key: "pdf", get: function get()
    {return this.apiUrl("/api/v1/pdfdownloads/");} // query, get, post, put
  }, { key: "checkinImage", get: function get()
    {return this.apiUrl("/api/v1/checkin-images/");} }, { key: "favoriteRecipes", get: function get()

    {return this.apiUrl("/api/v2/recipes-favorite/");} }, { key: "customRecipes", get: function get()

    {return this.apiUrl("/api/v2/custom-recipes/");} }, { key: "accountImage", get: function get()

    {return this.apiUrl("/api/v1/account-images");} }, { key: "weekNavigator", get: function get()

    {return this.apiUrl("/api/v1/checkins/week-navigator");} }, { key: "getActiveModule", get: function get()

    {return this.apiUrl("/api/v1/modules/active");} }, { key: "getKrogerAuthUrl", get: function get()

    {return this.apiUrl("/api/v1/kroger/get-kroger-auth-url/");} // get
  }, { key: "addWeekNumberKroger", get: function get() {return this.apiUrl("/api/v1/kroger/add-week-number-kroger/");} // get
  }, { key: "krogerSendCode", get: function get() {return this.apiUrl("/api/v1/kroger/send-code-kroger/");} // post
  }, { key: "krogerCheckAuth", get: function get() {return this.apiUrl("/api/v1/kroger/check-user-auth-kroger/");} // get
  }, { key: "krogerAddItems", get: function get() {return this.apiUrl("/api/v1/kroger/add-items-to-kroger-cart/");} // post
  }, { key: "instacartSendGroceryList", get: function get()
    {return this.apiUrl("/api/v1/instacart/send-groceries-list-to-instacart/");} // post
  }]);return ApiHttpService;}();


export function configureApiInterceptors($httpProvider) {
  "ngInject";
  $httpProvider.interceptors.push(ApiInterceptor);
}


function ApiInterceptor($q, gplansConf) {
  "ngInject";
  return {
    request: function request(config) {
      console.log('request', config);
      if (angular.isString(config.url)) {
        config.url = normalizeUrl(config.url, gplansConf.API_URL);
      }
      return config;
    },
    requestError: function requestError(rejection) {
      console.warn('requestError', rejection);
      return $q.reject(rejection);
    },
    response: function response(_response) {
      console.log('response', _response);
      return _response;
    },
    responseError: function responseError(rejection) {
      console.warn('responseError', rejection);
      return $q.reject(rejection);
    } };



  function normalizeUrl() {var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var apiBase = arguments.length > 1 ? arguments[1] : undefined;
    var _url = require('url');
    var _path = require('path');
    var urlObj = _url.parse(url);
    apiBase += '/api/';
    urlObj.pathname = _path.normalize(urlObj.pathname);
    if (url.startsWith(apiBase)) {
      if (!urlObj.pathname.endsWith('/')) urlObj.pathname += '/';
    }
    url = _url.format(urlObj);
    return url;
  }
}